<template>
  <layout-simple :title="$t('views.Error.title')">
    <v-container fluid>
      <v-row align="center">
        <error-list />
      </v-row>
    </v-container>
  </layout-simple>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

import LayoutSimple from "@/layouts/LayoutSimple.vue";
import ErrorList from "@/components/utility/ErrorList.vue";

@Component({
  components: { LayoutSimple, ErrorList }
})
export default class Error extends Vue {}
</script>
